import React, {Component} from 'react';
import keycode from 'keycode'
import WindowEventHelper from "../lib/WindowEventHelper";

class KeyShortcutApp extends Component {

    constructor(props) {
        super(props);

        this.handleMoveToBlogUrl = this.handleMoveToBlogUrl.bind(this);
    }

    componentDidMount() {
		WindowEventHelper.add("keydown", this.handleMoveToBlogUrl)
    }

    componentWillUnmount() {
		WindowEventHelper.remove("keydown", this.handleMoveToBlogUrl)
    }

    handleMoveToBlogUrl(e) {
		switch(e.target.tagName) {
			case 'INPUT':
			case 'SELECT':
			case 'TEXTAREA':
				return;
		}

        if (keycode(e) === 'q') {
			    window.location.href = window.Config.blog.domain;
        }
    }

    render() {
        return null;
    }
}

export default KeyShortcutApp;
